import React, { useEffect, useState } from 'react'
import { cn } from 'ethcss'
import { styles } from './integrations.jcss'
import Collapse from 'blocks.simple/collapse/collapse'
import translate from '../../../core/translate'
import styles_ from '../settings.jcss'
import Button from '../../../blocks.simple/button/button'
import { IIvideonEvents, IvideonEvents } from './__ivideonEvents/IvideonEvents'
import { api } from '../../../core/api/ConnectionManager'

interface IState {
    ivideonEvents: IIvideonEvents
}

export const Integrations = () => {
    const [integrations, setIntegrations] = useState<IState | null>(null)
    const collapseRef: { onClick?: () => void } = {}

    const onSave = () => {
        api.send('updateIntegrations', integrations).then(() => {
            if (collapseRef.onClick) {
                collapseRef.onClick()
            }
        })
    }

    const onChangeData = (value: any, field: string, integrationName: string) => {
        if (integrations && integrationName === 'ivideonEvents') {
            setIntegrations((prevState: IState | null) => {
                return prevState
                    ? {
                          ...prevState,
                          [integrationName]: {
                              ...prevState[integrationName],
                              [field]: value,
                          },
                      }
                    : null
            })
        }
    }

    useEffect(() => {
        api.send('getIntegrations', {})
    }, [])
    useEffect(() => {
        const listenersId: string[] = []

        api.addObserver(
            'integrationReceived',
            (data: IState) => {
                setIntegrations(data)
            },
            listenersId
        )
        api.addObserver(
            'integrationUpdated',
            (data: IState) => {
                setIntegrations(data)
            },
            listenersId
        )

        return () => {
            listenersId.forEach((id) => api.removeObserver(id))
        }
    }, [])

    return (
        integrations && (
            <Collapse
                refObj={collapseRef}
                title={() => translate('integrations')}
                className={cn(styles.wrapper, styles_.background)}
            >
                {integrations.ivideonEvents && (
                    <>
                        <IvideonEvents data={integrations.ivideonEvents} onChange={onChangeData} />
                        <div className={styles.buttonWrapper}>
                            <Button
                                mod="fill"
                                onClick={onSave}
                                disabled={
                                    integrations.ivideonEvents.events.every((event) => !event.selected) ||
                                    !integrations.ivideonEvents.apiKey
                                }
                            >
                                {translate('save')}
                            </Button>
                        </div>
                    </>
                )}
            </Collapse>
        )
    )
}
